import styled from 'styled-components/native';

const WarningWrapper = styled.View<{
  marginTop?: boolean;
  marginBottom?: boolean;
  isWarning?: boolean;
}>`
  background-color: ${(p) =>
    p.isWarning ? p.theme.colors.infoYellow : p.theme.colors.lightBg.green};
  padding: 20px;
  border-radius: 20px;
  margin-top: ${(p) => (p.marginTop ? 15 : 0)}px;
  margin-bottom: ${(p) => (p.marginBottom ? 15 : 0)}px;
  flex-direction: row;
  gap: 10px;
`;

export default WarningWrapper;
